<div
  class="app-aside-item"
  (click)="onClick($event)"
  (keydown.enter)="onEnter($event)"
  [qimaFloatingBadgeIsVisible]="!!notification && isCollapsed"
  [qimaFloatingBadgeLabel]="notification"
  [qimaFloatingBadgeRight]="'-5px'"
  [qimaFloatingBadgeSize]="badgeSizeSmall"
  [qimaFloatingBadgeStyle]="badgeStyle"
  [qimaFloatingBadgeTop]="'-5px'"
  qimaFloatingBadge
  [class.app-aside-item--checked]="isChecked"
  [class.app-aside-item--collapsed]="isCollapsed"
  [class.app-aside-item--custom-icon]="iconSrc"
>
  <div class="app-aside-item__left">
    @if (iconSrc) {
      <img
        alt=""
        class="app-aside-item__icon app-aside-item__icon-image"
        [src]="iconSrc"
      />
    } @else {
      <qima-icon
        [qimaIconName]="iconName"
        class="app-aside-item__icon"
      ></qima-icon>
    }
    <span
      *ngIf="!isCollapsed || isMobile"
      class="app-aside-item__label"
      >{{ label }}</span
    >
  </div>
  <qima-badge
    *ngIf="!!notification && !isCollapsed"
    [qimaBadgeLabel]="notification"
    [qimaBadgeSize]="badgeSizeMedium"
    [qimaBadgeStyle]="badgeStyle"
  ></qima-badge>
</div>
